import React from 'react';
import connect from 'react-redux/es/connect/connect';
import { withRouter } from 'react-router-dom';
import {
  Box, TextField, Container, Paper, Button,
} from '@material-ui/core';
import { MUIEditorState } from 'react-mui-draft-wysiwyg';
import htmlToDraft from 'html-to-draftjs';
import draftToHtml from 'draftjs-to-html';
import { ContentState, EditorState, convertToRaw } from 'draft-js';
import FormTitle from '../../../components/atoms/formTitle/FormTitle';
import FormErrorText from '../../../components/atoms/formErrorText/FormErrorText';
import SearchSelectBox from '../../../components/atoms/searchSelectBox/SearchSelectBox';
import FreeSoloBox from '../../../components/atoms/freeSoloBox/FreeSoloBox';
import Wysiwyg from '../../../components/atoms/wysiwyg/Wysiwyg';
import Validation from './validation';
import BasicBreadcrumbs from '../../../components/organisms/basicBreadcrumbs/BasicBreadcrumbs';
import urls from '../../../constants/urls';
import SuccessSnackbar from '../../../components/atoms/successSnackbar/SuccessSnackbar';
import {
  actCallInitMailTemplateList, actCallApiGetMailTemplate,
  actCallApiSaveMailTemplate, actResetMailTemplateFlg,
} from '../../../redux/setting/mailTemplate/action';

const tmpForm = {
  id: null,
  mstStore: null,
  title: '',
  subject: '',
  folder: '',
  content: '',
  draftContent: MUIEditorState.createEmpty(),
};

const tmpErrorMessage = {
  mstStore: '',
  title: '',
  folder: '',
  subject: '',
  content: '',
};

class MailTemplateDetail extends React.Component {
  constructor(props) {
    super(props);
    let isMain = false;
    const { id } = props.location.state;
    if (props.common.user) {
      isMain = props.common.user.main;
      tmpForm.mstStore = props.common.user.store;
    }

    this.breadcrumbsText = [
      {
        url: urls.SETTING.MAIL_TEMPLATE_LIST,
        name: 'メールテンプレート一覧',
      },
      { name: 'メールテンプレート詳細' },
    ];

    if (id) {
      props.dispatch(actCallApiGetMailTemplate({ id }));
    }

    props.dispatch(actCallInitMailTemplateList());

    this.state = {
      form: {
        ...tmpForm,
        id,
      },
      isMain,
      errorMessage: tmpErrorMessage,
      selects: {
        stores: [],
        folders: [],
      },
      isSuccessSnackOpen: false,
      successMessage: '',
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.mailTemplates.data !== this.props.mailTemplates.data) {
      if (this.props.mailTemplates.data) {
        this.setData(this.props.mailTemplates.data);
      }
    }
    if (prevProps.mailTemplates.select !== this.props.mailTemplates.select) {
      if (this.props.mailTemplates.select) {
        this.setSelect(this.props.mailTemplates.select);
      }
    }
    if (prevProps.mailTemplates.isSaveSuccess !== this.props.mailTemplates.isSaveSuccess) {
      if (this.props.mailTemplates.isSaveSuccess) {
        this.setSuccess(this.props.mailTemplates.saveId);
      }
    }
  }

  setSelect(selects) {
    this.setState({ selects });
  }

  setSuccess(saveId) {
    this.setState({
      successMessage: '保存が完了しました',
      isSuccessSnackOpen: true,
    });
    this.props.dispatch(
      actCallApiGetMailTemplate({ id: saveId }),
    );
    this.props.dispatch(actCallInitMailTemplateList());
  }

  setData = (data) => {
    const conv = htmlToDraft(data.content);
    const contentState = ContentState.createFromBlockArray(
      conv.contentBlocks,
      conv.entityMap,
    );
    const draftContent = EditorState.createWithContent(contentState);
    this.setState({
      form: {
        ...data,
        mstStore: {
          id: data.mstStoreId,
          name: data.storeName,
        },
        draftContent,
      },
    });
  };

  onSuccessSnackbarClose = () => {
    this.setState({ isSuccessSnackOpen: false });
  }

  onChange = (event) => {
    const { form, errorMessage } = this.state;
    const { name, value } = event.target;
    this.setState({
      form: {
        ...form,
        [name]: value,
      },
      errorMessage: {
        ...errorMessage,
        [name]: Validation.formValidate(name, value),
      },
    });
  };

  onChangeContent = (e) => {
    // draftContent draft→HTML
    const { form } = this.state;
    const { name, value } = e.target;
    const draftContent = convertToRaw(value.getCurrentContent());
    const content = draftToHtml(draftContent);
    this.setState({ form: { ...form, [name]: value, content } });
  };

  onClickUpsert = () => {
    const { form, errorMessage } = this.state;
    let tempMessage = errorMessage;
    let isError = false;

    Object.keys(form).forEach((key) => {
      const msg = Validation.formValidate(key, form[key]);
      if (msg) {
        isError = true;
      }
      tempMessage = {
        ...tempMessage,
        [key]: msg,
      };
    });

    this.setState({ errorMessage: tempMessage });

    if (isError) {
      return;
    }
    this.props.dispatch(actResetMailTemplateFlg());
    this.props.dispatch(actCallApiSaveMailTemplate({
      ...form,
      mstStoreId: form.mstStore && form.mstStore.id,
    }));
  }

  render() {
    const {
      form, errorMessage, isMain, selects, isSuccessSnackOpen, successMessage,
    } = this.state;

    return (
      <>
        <BasicBreadcrumbs breadcrumbs={this.breadcrumbsText} />
        <Container maxWidth={false} style={{ paddingTop: '60px', paddingBottom: '40px' }}>
          <Paper elevation={0} variant="outlined">
            <Box p={3}>
              {isMain && (
                <Box>
                  <FormTitle title="店舗" isRequired />
                  <SearchSelectBox options={selects.stores} value={form.mstStore} onChange={this.onChange} name="mstStore" disableClearable />
                  <FormErrorText>{errorMessage.mstStore}</FormErrorText>
                </Box>
              )}
              <Box mt={3}>
                <FormTitle title="フォルダ" isRequired />
                <FreeSoloBox
                  name="folder"
                  disableClearable
                  error={errorMessage.folder !== ''}
                  options={
                    form.mstStore
                      ? selects.folders.filter(
                        (folder) => folder.mstStoreId === form.mstStore.id,
                      )
                      : selects.folders
                  }
                  value={form.folder}
                  onChange={this.onChange}
                />
                <FormErrorText>{errorMessage.folder}</FormErrorText>
              </Box>
              <Box mt={3}>
                <FormTitle title="タイトル" isRequired />
                <TextField
                  name="title"
                  variant="outlined"
                  fullWidth
                  value={form.title}
                  onChange={this.onChange}
                  error={errorMessage.title !== ''}
                  inputProps={{
                    maxLength: 30,
                  }}
                />
                <FormErrorText>{errorMessage.title}</FormErrorText>
              </Box>
              <Box mt={3}>
                <FormTitle title="コンテンツ" isRequired />
                <Wysiwyg
                  onChange={this.onChangeContent}
                  value={form.draftContent}
                  name="draftContent"
                />
              </Box>
            </Box>
          </Paper>
          <Box align="center" my={2}>
            <Button
              color="primary"
              variant="contained"
              onClick={this.onClickUpsert}
            >
              保存する
            </Button>
          </Box>
        </Container>
        <SuccessSnackbar
          open={isSuccessSnackOpen}
          handleClose={this.onSuccessSnackbarClose}
          message={successMessage}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => ({ mailTemplates: state.mailTemplates, common: state.common });

export default withRouter(connect(mapStateToProps)(MailTemplateDetail));
